/**
 * French translations
 *
 * Machine-translated - requires professional review
 */
import type { TranslationStructure } from '../types';

export const fr: TranslationStructure = {
  common: {
    appName: 'Dashboard',
    loading: 'Chargement...',
    loadingDashboard: 'Chargement du Tableau de Bord...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    adding: 'Ajout en cours...',
    create: 'Créer',
    update: 'Mettre à jour',
    submit: 'Soumettre',
    confirm: 'Confirmer',
    back: 'Retour',
    next: 'Suivant',
    yes: 'Oui',
    no: 'Non',
    ok: 'OK',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Avertissement',
    info: 'Information',
    all: 'Tous',
    none: 'Aucun',
    search: 'Rechercher',
    filter: 'Filtrer',
    filters: 'Filtres',
    reset: 'Réinitialiser',
    refresh: 'Actualiser',
    download: 'Télécharger',
    upload: 'Téléverser',
    view: 'Voir',
    details: 'Détails',
    actions: 'Actions',
    status: 'Statut',
    date: 'Date',
    time: 'Heure',
    name: 'Nom',
    email: 'E-mail',
    description: 'Description',
    notes: 'Notes',
    type: 'Type',
    user: 'Utilisateur',
    role: 'Rôle',
    organization: 'Organisation',
    required: 'Requis',
    optional: 'Optionnel',
    notAvailable: 'N/D',
    other: 'Autre',
    goBack: 'Retourner',
  },

  roles: {
    admin: 'Administrateur',
    pilot: 'Pilote',
    maintenance: 'Maintenance',
    airspace_observer: "Observateur d'espace aérien",
  },

  profile: {
    myProfile: 'Mon Profil',
    userProfile: "Profil d'utilisateur",
    loadError: 'Échec du chargement du profil',
    notFound: 'Profil non trouvé',
    bio: 'Biographie',
    bioPlaceholder: 'Parlez-nous de vous...',
    noBio: "Aucune biographie ajoutée pour l'instant.",
    bioSaved: 'Biographie enregistrée avec succès',
    bioSaveError: "Échec de l'enregistrement de la biographie",
    fullName: 'Nom complet',
    noName: 'Nom non défini',
    nameSaved: 'Nom enregistré avec succès',
    nameSaveError: "Échec de l'enregistrement du nom",
    certifications: 'Certifications',
    noCertifications: "Aucune certification ajoutée pour l'instant.",
    addCertification: 'Ajouter une certification',
    certificationName: 'Nom de la certification',
    expiryDate: "Date d'expiration",
    uploadDocument: 'Téléverser un document',
    certificationAdded: 'Certification ajoutée avec succès',
    certificationAddError: "Échec de l'ajout de la certification",
    certificationRemoved: 'Certification supprimée avec succès',
    certificationRemoveError: 'Échec de la suppression de la certification',
    expired: 'Expiré',
    expiresOn: 'Expire le',
    deletePicture: 'Supprimer la photo',
    pictureUploaded: 'Photo de profil téléversée avec succès',
    pictureUploadError: 'Échec du téléversement de la photo de profil',
    pictureDeleted: 'Photo de profil supprimée avec succès',
    pictureDeleteError: 'Échec de la suppression de la photo de profil',
    memberSince: 'Membre depuis',
    totalPilotHours: 'Heures de Vol Totales en tant que Pilote',
  },

  auth: {
    signIn: 'Se connecter',
    signOut: 'Se déconnecter',
    signingOut: 'Déconnexion...',
    loginSuccessful: 'Connexion réussie',
    email: 'E-mail',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    fullName: 'Nom complet',
    forgotPassword: 'Mot de passe oublié ?',
    backToLogin: 'Retour à la connexion',
    authenticationRequired: 'Authentification requise',
    invitationOnly:
      "L'accès se fait uniquement sur invitation. Demandez à un administrateur de votre organisation de vous inviter.",
    emailRequired: "L'e-mail est requis",
    emailInvalid: 'Veuillez entrer une adresse e-mail valide',
    passwordRequired: 'Le mot de passe est requis',
    passwordMinLength: 'Le mot de passe doit contenir au moins 6 caractères',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    fullNameRequired: 'Le nom complet est requis',
    pendingApproval:
      "Votre compte est en attente d'approbation. Veuillez contacter un administrateur pour être assigné à une organisation avant de pouvoir vous connecter.",
  },

  passwordReset: {
    title: 'Réinitialiser le mot de passe',
    verifyCode: 'Vérifier le code',
    setNewPassword: 'Définir un nouveau mot de passe',
    emailPrompt: 'Entrez votre adresse e-mail et nous vous enverrons un code de vérification.',
    codeSentTo: 'Entrez le code à 6 chiffres envoyé à {{email}}',
    newPasswordPrompt: 'Entrez votre nouveau mot de passe ci-dessous.',
    sendVerificationCode: 'Envoyer le code de vérification',
    verificationCode: 'Code de vérification',
    codeHelperText: 'Entrez le code à 6 chiffres de votre e-mail',
    verifyCodeButton: 'Vérifier le code',
    resendCode: 'Renvoyer le code',
    resendCodeIn: 'Renvoyer le code dans {{seconds}}s',
    changeEmail: "Changer l'e-mail",
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    passwordHelperText: 'Doit contenir au moins 6 caractères',
    resetPasswordButton: 'Réinitialiser le mot de passe',
    updatingPassword: 'Mise à jour du mot de passe...',
    successTitle: 'Mot de passe réinitialisé avec succès !',
    successMessage:
      'Votre mot de passe a été mis à jour avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
    redirecting: 'Vous serez redirigé vers la page de connexion sous peu...',
    processUpdatedTitle: 'Processus de réinitialisation mis à jour',
    processUpdatedMessage:
      'Notre processus de réinitialisation de mot de passe a été mis à jour. Nous utilisons maintenant des codes de vérification au lieu de liens magiques pour une meilleure sécurité et compatibilité.',
    instructionsTitle: 'Pour réinitialiser votre mot de passe :',
    instruction1: 'Cliquez sur le bouton ci-dessous pour accéder à la page de réinitialisation',
    instruction2: 'Entrez votre adresse e-mail',
    instruction3: 'Entrez le code de vérification à 6 chiffres envoyé à votre e-mail',
    instruction4: 'Définissez votre nouveau mot de passe',
    goToPasswordReset: 'Aller à la réinitialisation',
    autoRedirect: 'Vous serez automatiquement redirigé dans 5 secondes...',
    codeRequired: 'Le code de vérification est requis',
    codeMustBe6Digits: 'Le code de vérification doit contenir 6 chiffres',
    invalidCode: 'Code de vérification invalide ou expiré',
    codeSent: 'Code de vérification envoyé à votre e-mail.',
    codeResent: 'Code de vérification renvoyé à votre e-mail.',
    codeVerified: 'Code vérifié avec succès !',
    passwordUpdated: 'Mot de passe mis à jour avec succès !',
  },

  invitation: {
    validating: "Validation de l'invitation...",
    invalidTitle: 'Invitation invalide',
    invalidMessage:
      "Cette invitation a peut-être expiré ou a déjà été utilisée. Veuillez contacter l'administrateur de votre organisation pour demander une nouvelle invitation.",
    goToLogin: 'Aller à la connexion',
    acceptTitle: "Accepter l'invitation",
    invitedTo: 'Vous avez été invité à rejoindre {{organization}}',
    enterFullName: 'Entrez votre nom complet',
    createAccountButton: "Créer un compte et rejoindre l'organisation",
    creatingAccount: 'Création du compte...',
    successTitle: 'Compte créé avec succès !',
    accountCreated: 'Compte créé avec succès. Vous pouvez maintenant vous connecter.',
    welcomeMessage:
      'Bienvenue chez {{organization}} ! Votre compte est prêt. Vous serez redirigé vers la page de connexion sous peu.',
    redirectingToLogin: 'Vous serez redirigé vers la page de connexion sous peu...',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    signInHere: 'Connectez-vous ici',
    noToken: "Aucun jeton d'invitation fourni",
    invalidData: "Données d'invitation invalides",
    userCreationFailed:
      "Compte créé mais l'identifiant utilisateur n'a pas été retourné. Veuillez essayer de vous connecter.",
  },

  noOrganization: {
    title: "Compte en attente d'approbation",
    message:
      'Votre compte a été créé avec succès ! Veuillez contacter un administrateur pour être assigné à une organisation avant de pouvoir accéder au panneau de maintenance.',
    loggedInAs: 'Connecté en tant que : {{email}}',
  },

  header: {
    plotFlightData: 'Tracer les données de vol',
    adminTools: "Outils d'administration",
  },

  tabs: {
    overview: 'Aperçu',
    files: 'Fichiers',
    profile: 'Profil',
    maintenance: 'Maintenance',
    healthPanel: 'Panneau de santé',
    inventory: 'Inventaire',
    calendar: 'Calendrier',
  },

  filterDialog: {
    fileFilters: 'Filtres de fichiers',
    droneSerial: 'Numéro de série du drone',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    resetFileFilters: 'Réinitialiser les filtres de fichiers',
    sortOptions: 'Options de tri',
    sortBy: 'Trier par',
    sortByName: 'Nom',
    sortByDate: 'Date',
    sortBySerial: 'Numéro de série',
    ascending: 'Crois.',
    descending: 'Décrois.',
  },

  overview: {
    fleetOverview: 'Aperçu de la flotte',
    fleetSummary: 'Résumé de la flotte',
    totalDrones: 'Total des drones',
    totalEngineHours: 'Total heures moteur',
    totalFlightHours: 'Total heures de vol',
    allDrones: 'Tous les drones',
    clickToViewProfile: 'Cliquez sur une carte de drone pour voir le profil',
    noDronesFound: 'Aucun drone trouvé pour votre organisation',
    latestFlights: 'Derniers vols',
    noFlightsRecorded: 'Aucun vol enregistré pour le moment',
    failedToLoadFlights: 'Impossible de charger les derniers vols',
    drone: 'Drone',
    maintenance: 'Maintenance',
    flightHours: 'Heures de vol',
    engineHours: 'Heures moteur',
    overdue: 'EN RETARD : {{hours}}h',
    next: 'Suivant : {{hours}}h',
    personnel: {
      title: 'Aperçu du personnel',
      pilots: 'Pilotes',
      maintenanceEngineers: 'Ingénieurs de maintenance',
      noPilots: 'Aucun pilote trouvé dans votre organisation',
      noMaintenanceEngineers: 'Aucun ingénieur de maintenance trouvé dans votre organisation',
      unnamed: 'Sans nom',
      roles: {
        pilot: 'Pilote',
        maintenance: 'Maintenance',
      },
    },
  },

  droneStatus: {
    airworthy: 'Navigable',
    airworthyTooltip: 'Le drone est navigable et prêt pour les opérations',
    airworthyWithLimitations: 'Navigable avec limitations',
    airworthyWithLimitationsTooltip:
      'Le drone est navigable mais a des limitations opérationnelles',
    maintenance: 'Maintenance',
    maintenanceTooltip: 'Le drone est actuellement en maintenance',
    notAirworthy: 'Non navigable',
    notAirworthyTooltip: "Le drone n'est pas navigable et ne peut pas être opéré",
    withCustomer: 'Chez le client',
    withCustomerTooltip: 'Le drone est actuellement chez un client',
    inProduction: 'En production',
    inProductionTooltip:
      "Le drone est en cours de fabrication ou d'assemblage et n'est pas encore en service",
    failedToUpdate: 'Impossible de mettre à jour le statut du drone',
  },

  // Drone Picture
  dronePicture: {
    failedToUpload: "Impossible de télécharger l'image du drone",
  },

  profileTab: {
    selectDrone: 'Sélectionnez un drone pour voir les statistiques',
    droneInformation: 'Informations sur le drone',
    plotData: 'Tracer les données',
    totalFiles: 'Total des fichiers',
    firstFlight: 'Premier vol',
    firstEngineRun: 'Premier démarrage moteur',
    engineStarts: 'Démarrages moteur',
    engineHours: 'Heures moteur',
    flightHours: 'Heures de vol',
    // #1612: the definition shown under the figure on the drone page.
    flightHoursDefinition:
      "Temps en vol, d'après l'indicateur de vol de l'enregistreur (régime du générateur au-dessus de 5 100 tr/min si un journal n'en a pas).",
    hoursBreakdown: '({{tracked}} enregistrées + {{legacy}} historiques)',
    droneStatusLabel: 'Statut du drone',
    statusUpdated: 'Statut du drone mis à jour à {{status}}',
    invalidDate: 'Date invalide',
    ownershipLabel: 'Propriété',
    ownershipSold: 'Vendu',
    ownershipLeased: 'Loué',
    leaseEnds: 'fin',
    failedToLoadStatus: 'Échec du chargement du statut du drone',
  },

  dronePageShared: {
    sharedBy: 'Partagé par {{org}}',
    sharedByUnknown: 'Partagé par une autre organisation',
    countersIncludeSharedOne: 'Inclut {{count}} vol partagé par {{orgs}}',
    countersIncludeSharedOther: 'Inclut {{count}} vols partagés par {{orgs}}',
    timelineShared: 'Inclut des vols partagés : {{orgs}}',
    trendPointShared: 'Partagé par {{org}}',
  },

  technicalSpecs: {
    title: 'Spécifications techniques',
    subtitle: 'Configuration, Logiciel, Numéros de série et Options',
    configuration: 'Configuration',
    software: 'Logiciel',
    serialNumbers: 'Numéros de série',
    options: 'Options',
    updatedSuccessfully: '{{field}} mis à jour avec succès',
    failedToUpdate: 'Impossible de mettre à jour la spécification technique',
    tempSensorCableClip: 'Clip de fixation du câble de la sonde de température',
    notSet: 'Non renseigné',
  },

  notes: {
    title: 'Notes',
    notesFor: 'Notes pour {{serial}}',
    summary: '{{total}} total • {{unresolved}} non résolues • {{resolved}} résolues',
    filters: 'Filtres',
    createNote: 'Créer une note',
    search: 'Rechercher',
    type: 'Type',
    allTypes: 'Tous les types',
    general: 'Général',
    customerFeedback: 'Commentaires client',
    alert: 'Alerte',
    priority: 'Priorité',
    allPriorities: 'Toutes les priorités',
    information: 'Information',
    critical: 'Critique',
    includeResolved: 'Inclure les résolues',
    selectDroneToView: 'Sélectionnez un drone pour voir les notes',
    noNotesFound: 'Aucune note trouvée',
    createFirstNote: 'Créez votre première note',
    addNote: 'ajouter une note',
    failedToLoad: 'Échec du chargement des notes',
    failedToCreate: 'Échec de la création de la note',
    failedToUpdate: 'Échec de la mise à jour de la note',
    failedToDelete: 'Échec de la suppression de la note',
    failedToResolve: 'Échec de la résolution de la note',
    failedToUnresolve: 'Échec de la réouverture de la note',
  },

  maintenanceTab: {
    selectDrone: 'Sélectionnez un drone pour voir les enregistrements de maintenance',
    upcomingMaintenance: 'Maintenance à venir',
    addMaintenance: 'Ajouter une maintenance',
    maintenanceHistory: 'Historique de maintenance',
    componentMaintenanceSchedule: 'Programme de maintenance des composants',
    visualInspectionSchedule: "Programme d'inspection visuelle",
    noUpcoming: 'Aucune maintenance à venir programmée',
    noHistory: 'Aucun historique de maintenance disponible',

    // Schedule card
    overdue: 'EN RETARD',
    dueIn: 'À faire dans :',
    hrsOverdue: '{{hours}} hrs en retard',
    hrs: '{{hours}} hrs',
    trackingOnly: 'Suivi uniquement',
    hrsAccumulated: '{{hours}} hrs accumulées',
    viewMaintenanceManual: 'Voir le manuel de maintenance',
    viewInspectionInstructions: "Voir les instructions d'inspection",

    // Historical/Record card
    performedBy: 'Effectué par :',
    addedBy: 'Ajouté par :',
    reviewedBy: 'Révisé par :',
    qualityChecked: 'Qualité vérifiée',
    workOrderId: "ID de l'ordre de travail :",
    unknown: 'Inconnu',

    // Record statuses
    statusCompleted: 'Terminé',
    statusCancelled: 'Annulé',
    statusPending: 'En attente',

    // View dialog
    workDescription: 'Description du travail',
    qualityCheckedBy: 'Qualité vérifiée par :',
    deleteMaintenanceRecord: "Supprimer l'enregistrement de maintenance",
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cet enregistrement de maintenance ?',
    deleteRecalculationWarning:
      'Cette action déclenchera le recalcul automatique des compteurs de maintenance pour le drone',
    deleteSuccess: 'Enregistrement de maintenance supprimé avec succès',
    deleteFailed: "Échec de la suppression de l'enregistrement de maintenance. Veuillez réessayer.",

    // Record form
    startDate: 'Date de début :',
    endDate: 'Date de fin :',
    startDateLabel: 'Date de début',
    endDateLabel: 'Date de fin',
    maintenancePerformed: 'Maintenance effectuée',
    unknownUser: 'Utilisateur inconnu',
    differentUserRequired: '(Autre utilisateur requis)',
    failedToOpenManual: "Impossible d'ouvrir le manuel de maintenance",
    failedToLoadTimeline: 'Impossible de charger la chronologie de maintenance',
    failedToDownloadAttachment: 'Impossible de télécharger la pièce jointe de maintenance',
  },

  // Statistics mutations
  statistics: {
    failedToFetchWeather: 'Impossible de récupérer les données météo',
    failedToUpdateFlight: 'Impossible de mettre à jour les métadonnées de vol',
    failedToUploadAttachment: 'Impossible de téléverser la pièce jointe',
  },

  filesTab: {
    title: 'Fichiers',
    uploadFile: 'Téléverser un fichier',
    noFiles: 'Aucun fichier trouvé',
    fileName: 'Nom du fichier',
    fileSize: 'Taille',
    uploadedBy: 'Téléversé par',
    uploadedAt: 'Téléversé le',
    downloadFile: 'Télécharger le fichier',
    deleteFile: 'Supprimer le fichier',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
  },

  fileManagement: {
    title: 'Gestion des fichiers',
    root: 'Racine',
    sharedFolderChip: 'Partagé avec vous',
    backToShared: 'Retour à Partagé',
    folderNotFoundTitle: 'Dossier introuvable',
    folderNotFoundBody:
      "Ce lien ne mène à aucun dossier que vous pouvez ouvrir. Il a peut-être été supprimé, ou il n'a jamais été partagé avec votre organisation.",
    notAFolderTitle: 'Ce lien pointe vers un fichier',
    notAFolderBody:
      "Les liens de dossier ouvrent un dossier. Celui-ci nomme un fichier : il n'y a donc rien à lister — ouvrez-le depuis le dossier qui le contient.",
    backToMyFiles: 'Retour à mes fichiers',
    folderFileCount: '{{count}} fichiers',
    folderSerial: 'Drone {{serial}}',
    showingOfTotal: 'Affichage de {{shown}} sur {{total}}',
    newFolder: 'Nouveau dossier',
    uploadFiles: 'Téléverser des fichiers',
    hideUpload: 'Masquer le téléversement',
    documents: 'Documents',
    reports: 'Rapports',
    noFilesInDirectory: 'Aucun fichier trouvé dans ce répertoire',
    moreActions: "Plus d'actions",
    download: 'Télécharger',
    downloadMany: 'Télécharger ({{count}} fichiers)',
    bulkDownloadProgress: 'Téléchargement {{done}} sur {{total}}...',
    bulkDownloadBrowserHint:
      'Votre navigateur peut demander une fois si ce site peut télécharger plusieurs fichiers.',
    bulkDownloadDone: '{{count}} téléchargements lancés.',
    bulkDownloadPartial:
      '{{started}} téléchargements lancés sur {{total}}. Non téléchargés : {{names}}',
    rename: 'Renommer',
    move: 'Déplacer',
    delete: 'Supprimer',
    plot: 'Tracer',
    details: 'Détails',
    moving: 'Déplacement : {{fileName}}',
    moveInstructions: 'Naviguez vers le dossier de destination et cliquez sur "Déplacer ici"',
    moveHere: 'Déplacer ici',
    createNewFolder: 'Créer un nouveau dossier',
    folderName: 'Nom du dossier',
    folderNameInvalidDots: "Le nom du dossier ne peut pas contenir '..' (risque de sécurité)",
    folderNameInvalidStart: 'Le nom du dossier ne peut pas commencer par des séparateurs de chemin',
    folderNameInvalidSlash: "Le nom du dossier ne peut pas contenir de barres obliques ('/')",

    // Rename folder dialog
    renameFolderTitle: 'Renommer le dossier',
    newFolderName: 'Nouveau nom du dossier',

    uploadingTo: 'Téléversement vers : {{path}}',
    flightAnalysisResults: "Résultats de l'analyse de vol",
    rowsProcessed: 'Lignes traitées',
    columnsProcessed: 'Colonnes traitées',
    extractedMetadata: 'Métadonnées extraites',
    dropFilesHere: 'Déposez les fichiers ici',
    dragAndDropFiles: 'Glissez et déposez des fichiers ici',
    orClickToBrowse: 'ou cliquez pour parcourir les fichiers',
    allowedFilesInfo: 'Autorisés : {{types}} (Max : {{maxFiles}} fichiers)',
    selectedFiles: 'Fichiers sélectionnés ({{count}})',
    analyze: 'Analyser',
    remove: 'Supprimer',
    uploadingProgress: 'Téléversement... {{progress}}%',
    clearAll: 'Tout effacer',
    uploadSettings: 'Paramètres de téléversement',
    destination: 'Destination :',
    destinationHelp:
      'Les fichiers seront téléversés dans le dossier que vous parcourez actuellement. Naviguez vers votre dossier cible avant de téléverser.',
    flightTypeRequired: 'Type de vol *',
    loadingFlightTypes: 'Chargement des types de vol...',
    selectFlightType: 'Sélectionner le type de vol',
    payloadRequired: 'Charge utile *',
    loadingPayloads: 'Chargement des charges utiles...',
    selectPayload: 'Sélectionner la charge utile',
    pilotRequired: 'Pilote *',
    loadingPilots: 'Chargement des pilotes...',
    selectPilot: 'Sélectionner le pilote',
    customer: 'Client',
    loadingCustomers: 'Chargement des clients...',
    selectCustomer: 'Sélectionner le client',
    addCustomer: 'Ajouter un nouveau client',
    addNewCustomer: 'Ajouter un nouveau client',
    customerName: 'Nom du client',
    customerAdded: 'Client ajouté avec succès',
    failedToAddCustomer: "Échec de l'ajout du client",
    project: 'Projet',
    loadingProjects: 'Chargement des projets...',
    selectProject: 'Sélectionner le projet',
    addProject: 'Ajouter un nouveau projet',
    addNewProject: 'Ajouter un nouveau projet',
    projectName: 'Nom du projet',
    projectAdded: 'Projet ajouté avec succès',
    failedToAddProject: "Échec de l'ajout du projet",
    addPayload: 'Ajouter une nouvelle charge utile',
    addNewPayload: 'Ajouter une nouvelle charge utile',
    payloadName: 'Nom de la charge utile',
    payloadWeight: 'Poids (kg)',
    payloadAdded: 'Charge utile ajoutée avec succès',
    failedToAddPayload: "Échec de l'ajout de la charge utile",
    airspaceObserver: "Observateur de l'espace aérien",
    loadingAirspaceObservers: "Chargement des observateurs de l'espace aérien...",
    selectAirspaceObserver: "Sélectionner l'observateur de l'espace aérien",
    payloadOperator: 'Opérateur de charge utile',
    loadingPayloadOperators: 'Chargement des opérateurs de charge utile...',
    selectPayloadOperator: "Sélectionner l'opérateur de charge utile",
    flightTypePayloadRequired:
      'Le type de vol et la charge utile sont requis pour les fichiers CSV de données de vol',
    flightTypePayloadPilotRequired:
      'Le type de vol, la charge utile et le pilote sont requis pour les fichiers CSV de données de vol',
    documentFilesInfo:
      'Les fichiers documents seront téléversés directement - aucune métadonnée de vol requise',
    testModeLabel: 'Téléverser comme données de test (contourner la validation)',
    filesToUpload: 'Fichiers à téléverser :',
    uploadCount: 'Téléverser {{count}} fichier(s)',
    uploadSuccess: '{{count}} fichier(s) téléversé(s) avec succès',
    fileAnalyzed: 'Fichier analysé avec succès',
    fileDeleted: 'Fichier supprimé avec succès',
    folderDeleted: 'Dossier supprimé avec succès',
    folderCreated: 'Dossier créé avec succès',
    fileMoved: 'Fichier déplacé avec succès',
    itemsMoved: '{{count}} élément(s) déplacé(s) avec succès',
    itemsMovedPartial: '{{moved}} déplacé(s), {{failed}} échoué(s) : {{names}}',
    folderMoved: 'Dossier déplacé avec succès',
    folderRenamed: 'Dossier renommé avec succès',
    downloadStarted: 'Téléchargement démarré',
    includeUntaggedData: 'Inclure les données non balisées',
    failedToLoadFiles: 'Échec du chargement des fichiers',
    failedToUpload: 'Échec du téléversement',
    failedToAnalyze: "Échec de l'analyse",
    failedToDownload: 'Échec du téléchargement',
    failedToDelete: 'Échec de la suppression du fichier',
    failedToDeleteFolder: 'Échec de la suppression du dossier',
    failedToMove: "Échec du déplacement de l'élément",
    failedToCreateFolder: 'Échec de la création du dossier',
    failedToRenameFolder: 'Échec du renommage du dossier',
    failedToGenerateUrl: "Échec de la génération de l'URL de téléchargement",
    cannotMoveToSameLocation: "Impossible de déplacer l'élément au même emplacement",
    maxFilesAllowed: 'Maximum {{count}} fichiers autorisés',
    invalidFileTypes: 'Types de fichiers invalides. Autorisés : {{types}}',
    selectFilesToUpload: 'Veuillez sélectionner des fichiers à téléverser',
    selectFlightTypeForCsv: 'Veuillez sélectionner un type de vol pour les fichiers CSV',
    selectPayloadForCsv: 'Veuillez sélectionner une charge utile pour les fichiers CSV',
    selectPilotForCsv: 'Veuillez sélectionner un pilote pour les fichiers CSV',
    failedToLoadData:
      'Échec du chargement des types de vol, charges utiles et pilotes. Veuillez réessayer.',
    analysisCompleted: 'Analyse terminée pour {{fileName}}',
    testData: 'Données de test',
    unknownFile: 'Fichier inconnu',

    // Duplicate file handling
    duplicateFilesSkipped: 'Fichiers en double ignorés',
    duplicateFilesMessage:
      'Les {{count}} fichier(s) suivants ont été ignorés car ils existent déjà :',
  },

  // Flight Reports
  reports: {
    title: 'Rapports de Vol',
    backToFiles: '← Retour aux Fichiers',
    generateReport: 'Générer un Rapport',
    noReports: 'Aucun Rapport',
    generateFirstReport: "Générez votre premier rapport d'heures de vol",

    // Loading/Error states
    failedToLoad: 'Échec du chargement des rapports',
    failedToGenerateUrl: "Échec de la génération de l'URL de téléchargement",
    failedToDownload: 'Échec du téléchargement du rapport',
    failedToDelete: 'Échec de la suppression du rapport',
    failedToLoadFilters: 'Échec du chargement des options de filtre',

    // Actions
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer "{{title}}" ?',
    deleteSuccess: 'Rapport "{{title}}" supprimé avec succès',
    deleteFailed: 'Échec de la suppression du rapport',
    moreActions: "Plus d'actions",
    download: 'Télécharger',
    delete: 'Supprimer',
    downloadStarted: 'Téléchargement démarré pour "{{title}}"',

    // Generation dialog
    generateReportTitle: "Générer un Rapport d'Heures de Vol",
    reportTitle: 'Titre du Rapport',
    titlePlaceholder: 'ex., Résumé des Vols Q4 2025',
    titleRequired: 'Le titre du rapport est requis',
    datesRequired: 'Les dates de début et de fin sont requises',
    invalidDateRange: 'La date de début doit être antérieure à la date de fin',
    startDate: 'Date de Début',
    endDate: 'Date de Fin',
    selectDrones: 'Sélectionner les Drones',
    allDrones: 'Tous les Drones',
    selectPayloads: 'Sélectionner les Charges Utiles',
    allPayloads: 'Toutes les Charges Utiles',
    selectPilots: 'Sélectionner les Pilotes',
    allPilots: 'Tous les Pilotes',
    leaveEmptyForAll: 'Laisser vide pour inclure tous',
    includeIncidents: 'Incidents/Accidents',
    generate: 'Générer le Rapport',
    generateSuccess: 'Rapport généré avec succès',
    generateFailed: 'Échec de la génération du rapport',

    // Content type selection
    includeInReport: 'Inclure dans le Rapport',
    includeFlightHours: 'Heures de Vol',
    includeMaintenanceData: 'Données de Maintenance',
    selectAtLeastOne: 'Sélectionnez au moins un type de contenu à inclure dans le rapport',

    // Maintenance filters
    maintenanceTypes: 'Types de Maintenance',
    allMaintenanceTypes: 'Tous les Types de Maintenance',
    maintenanceTypesHelper: 'Laisser vide pour inclure tous les types de maintenance',
  },

  healthPanel: {
    title: 'Panneau de santé',
    selectDrone: 'Sélectionnez un drone pour voir le panneau de santé',
    systemHealth: 'Santé du système',
    lastUpdated: 'Dernière mise à jour',
    noData: 'Aucune donnée de santé disponible',

    // Panel titles
    engineStartup: 'Démarrage du moteur',
    performance: 'Performance',
    cooling: 'Refroidissement',
    batteries: 'Batteries',
    fuelSystem: 'Système de carburant',
    liftSystem: 'Système de levage',

    // Panel info content
    performanceInfo:
      'Plage normale : 80-100%. Tendance calculée par régression linéaire sur les données de vol historiques.',
    coolingInfo:
      'Plage normale : 0-125°C. Tendance calculée par régression linéaire sur les données de vol historiques.',

    // Analysis displays
    latest: 'Dernier {{title}} :',
    trend: 'Tendance :',
    forecast: 'Prévision :',
    forecastBy: "d'ici {{date}}",
    rSquared: '(R² = {{value}})',
    insufficientData:
      "Données insuffisantes pour l'analyse de tendance (au moins 3 points de données requis)",

    // Click-a-point formula popup
    pointFormula: 'Formule',
    pointValues: 'Valeurs de ce vol',
    pointNoSources: "Les valeurs sources de ce vol n'ont pas été enregistrées.",
    pointNoFormula: 'Aucun détail de formule pour cette métrique.',

    // Status labels
    statusNormal: 'NORMAL',
    statusWarning: 'ATTENTION',
    statusUnknown: 'INCONNU',
    outOfBandFlights: '{{count}} vol(s) sur {{total}} hors de la plage acceptable',

    // TUWT display
    warningTime: "Temps d'avertissement",
    errorTime: "Temps d'erreur",
    ofTotal: '({{percentage}}% du total)',
    totalMonitoringTime: 'Temps de surveillance total :',

    // Trend labels
    trendImproving: 'EN AMÉLIORATION',
    trendWorsening: 'EN DÉGRADATION',
    trendStable: 'STABLE',
    trendLabel: 'Tendance : {{trend}}',
  },

  admin: {
    title: "Outils d'administration",
    droneManagement: 'Gestion des drones',
    userManagement: 'Gestion des utilisateurs',
    organizationManagement: 'Gestion des organisations',
    announcements: 'Annonces',
    inviteUser: 'Inviter un utilisateur',
    createDrone: 'Créer un drone',
    createOrganization: 'Créer une organisation',
    createAnnouncement: 'Créer une annonce',
    users: 'Utilisateurs',
    userName: 'Nom',
    userEmail: 'E-mail',
    userRole: 'Rôle',
    userOrganization: 'Organisation',
    userStatus: 'Statut',
    editUser: "Modifier l'utilisateur",
    deleteUser: "Supprimer l'utilisateur",
    assignOrganization: 'Assigner une organisation',
    roleAdmin: 'Administrateur',
    roleUser: 'Utilisateur',
    roleMaintainer: 'Mainteneur',
    drones: 'Drones',
    droneSerial: 'Numéro de série',
    droneOrganization: 'Organisation',
    editDrone: 'Modifier le drone',
    deleteDrone: 'Supprimer le drone',
    organizations: 'Organisations',
    orgName: 'Nom',
    orgSlug: 'Slug',
    editOrganization: "Modifier l'organisation",
    deleteOrganization: "Supprimer l'organisation",
    announcementTitle: 'Titre',
    announcementContent: 'Contenu',
    announcementPriority: 'Priorité',
    priorityLow: 'Basse',
    priorityMedium: 'Moyenne',
    priorityHigh: 'Haute',
    editAnnouncement: "Modifier l'annonce",
    deleteAnnouncement: "Supprimer l'annonce",
  },

  inviteDialog: {
    title: 'Inviter un utilisateur',
    emailLabel: 'Adresse e-mail',
    emailPlaceholder: "Entrez l'adresse e-mail",
    roleLabel: 'Rôle',
    sendInvitation: "Envoyer l'invitation",
    sending: 'Envoi en cours...',
    successMessage: 'Invitation envoyée avec succès à {{email}}',
    errorMessage: "Échec de l'envoi de l'invitation",
  },

  inbox: {
    title: 'Boîte de réception',
    noMessages: 'Aucun message',
    markAsRead: 'Marquer comme lu',
    markAllAsRead: 'Tout marquer comme lu',
    delete: 'Supprimer',
    failedToLoad: 'Impossible de charger les annonces',
    failedToMarkRead: "Impossible de marquer l'annonce comme lue",
    failedToDownloadAttachment: 'Impossible de télécharger la pièce jointe',
  },

  documents: {
    title: 'Documents',
    backToFiles: '← Retour aux Fichiers',
    uploadDocument: 'Téléverser un Document',
    noDocuments: 'Aucun document trouvé',
    uploadFirstDocument: 'Téléversez votre premier document pour commencer',
    moreActions: "Plus d'actions",
    download: 'Télécharger',
    delete: 'Supprimer',
    validUntil: "Valide jusqu'au :",

    typeInsurance: 'Assurance',
    typePermit: 'Permis',
    typeOther: 'Autre',

    selectFile: 'Sélectionner un Fichier',
    titleLabel: 'Titre',
    descriptionLabel: 'Description',
    documentType: 'Type de Document',
    validityStartDate: 'Date de Début de Validité (Optionnel)',
    validityEndDate: 'Date de Fin de Validité (Optionnel)',

    titleRequired: 'Le titre est requis',
    pleaseSelectFile: 'Veuillez sélectionner un fichier',
    startDateBeforeEnd: 'La date de début doit être antérieure à la date de fin',

    uploadSuccess: 'Document téléversé avec succès',
    uploadFailed: 'Échec du téléversement',
    downloadedDocument: '{{title}} téléchargé',
    failedToGenerateUrl: "Échec de la génération de l'URL de téléchargement",
    failedToDownload: 'Échec du téléchargement du document',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer "{{title}}" ?',
    deleteSuccess: 'Document {{title}} supprimé avec succès',
    deleteFailed: 'Échec de la suppression',
    failedToDelete: 'Échec de la suppression du document',
    failedToLoad: 'Échec du chargement des documents',
    failedToUpload: 'Échec du téléversement du document',
  },

  sessionTimeout: {
    title: 'Expiration de session',
    message: "Votre session est sur le point d'expirer en raison de l'inactivité.",
    stayLoggedIn: 'Rester connecté',
    logout: 'Se déconnecter',
    expiresIn: 'La session expire dans {{seconds}} secondes',
  },

  chat: {
    title: 'Chat',
    placeholder: 'Tapez un message...',
    send: 'Envoyer',
    minimize: 'Réduire',
    close: 'Fermer le chat',
    failedToLoadPageImage: "Échec du chargement de l'image de la page",
  },

  errors: {
    generic: "Une erreur s'est produite. Veuillez réessayer.",
    networkError: 'Erreur réseau. Veuillez vérifier votre connexion.',
    unauthorized: "Vous n'êtes pas autorisé à effectuer cette action.",
    notFound: "La ressource demandée n'a pas été trouvée.",
    serverError: 'Erreur serveur. Veuillez réessayer plus tard.',
    validationError: 'Veuillez vérifier votre saisie et réessayer.',
    sessionExpired: 'Votre session a expiré. Veuillez vous reconnecter.',
    failedToLoad: 'Échec du chargement des données. Veuillez réessayer.',
    failedToSave: "Échec de l'enregistrement des modifications. Veuillez réessayer.",
    failedToDelete: 'Échec de la suppression. Veuillez réessayer.',
  },

  // Admin Tools Page
  adminToolsPage: {
    // Page header
    title: "Outils d'Administration",
    subtitle: "Outils et utilitaires d'administrateur",
    backToDashboard: 'Retour au Tableau de Bord',

    // Access denied
    accessDenied: 'Accès Refusé',
    adminOnlyMessage: "Cette page n'est accessible qu'aux administrateurs.",
    returnToDashboard: 'Retour au Tableau de Bord',

    // Common labels
    xerAdminOnly: 'Admin XER Uniquement',
    users: 'Utilisateurs',
    close: 'Fermer',
    cancel: 'Annuler',
    assign: 'Assigner',

    // Roles
    roles: {
      admin: 'Admin',
      adminDesc: 'Accès complet au système',
      pilot: 'Pilote',
      pilotDesc: 'Opérations de vol',
      maintenance: 'Maintenance',
      maintenanceDesc: 'Opérations de maintenance',
      airspaceObserver: "Observateur d'Espace Aérien",
      airspaceObserverDesc: 'Surveillance uniquement',
      noRolesAssigned: 'Aucun rôle attribué',
    },

    // Metadata Extraction Card
    metadataExtraction: {
      title: "Relancer l'Extraction des Métadonnées",
      description:
        "Re-traiter les fichiers CSV pour extraire des métadonnées fraîches à l'aide du dernier extracteur de métadonnées XER. Cela met à jour les données de vol dans la base de données.",
      processingScope: 'Portée du traitement :',
      xerOnly: 'XER Technologies uniquement',
      allOrganizations: 'TOUTES les organisations',
      extractingFiles:
        'Extraction des métadonnées des fichiers CSV... ({{current}}/{{total}} fichiers)',
      startedBy: 'Démarré par : {{user}} à {{time}}',
      processingNote:
        'Ce processus peut prendre plusieurs minutes pour les grandes collections de fichiers.',
      processingInProgress: 'Traitement en cours...',
      successMessage: '{{processed}}/{{total}} fichiers CSV traités avec succès',
      failedMessage: '{{message}}',
      filesFailed: "{{count}} fichiers n'ont pas pu être traités",
      completedIn: 'Terminé en {{seconds}} secondes',
      s3Modified: '{{count}} fichiers S3 modifiés avec des données CSV améliorées',
      detailedLog: 'Journal détaillé :',
      download: 'Télécharger',
      failedFiles: 'Fichiers échoués :',
      andMore: '... et {{count}} de plus',
      jobRunning: 'Tâche en cours...',
      processing: 'Traitement...',
      startGlobalReExtraction: 'Démarrer Extraction Globale',
      startReExtraction: "Démarrer l'Extraction",
    },

    // Add Drone Card
    addDrone: {
      title: 'Ajouter un Nouveau Drone à la Base de Données',
      description:
        "Ajouter un nouveau numéro de série de drone à la base de données. Cela permet les téléversements de données de vol pour ce drone. Les drones sont automatiquement assignés à l'organisation XER Technologies.",
      buttonLabel: 'Ajouter un Nouveau Drone',
      dialogTitle: 'Ajouter un Nouveau Drone à la Base de Données',
      serialNumber: 'Numéro de Série *',
      serialNumberPlaceholder: 'Entrer le numéro de série du drone',
      model: 'Modèle (Optionnel)',
      modelPlaceholder: 'Entrer le modèle du drone',
      commissioningDate: 'Date de Mise en Service (Optionnel)',
      serialRequired: 'Le numéro de série est requis',
      notes: {
        uniqueSerial: 'Le numéro de série est requis et doit être unique',
        assignedToXer: "Le drone sera assigné à l'organisation XER Technologies",
        activeByDefault: "Le statut sera défini sur 'actif' par défaut",
      },
      adding: 'Ajout...',
      addDrone: 'Ajouter Drone',
    },

    // User Management Card
    userManagement: {
      title: 'Gestion des Utilisateurs',
      description:
        "Voir tous les utilisateurs de votre organisation et leurs rôles assignés. Surveiller l'accès des utilisateurs et les permissions sur la plateforme.",
      viewUsers: 'Voir les Utilisateurs',
      inviteUser: 'Inviter un Utilisateur',
      tableHeaders: {
        name: 'Nom',
        email: 'Email',
        roles: 'Rôles',
        joined: 'Inscription',
        actions: 'Actions',
      },
      noUsersFound: 'Aucun utilisateur trouvé dans cette organisation.',
    },

    // Organization Management Card
    orgManagement: {
      title: 'Gestion des Organisations',
      description:
        "Voir et gérer toutes les organisations du système. Surveiller les paramètres d'organisation et l'accès sur la plateforme.",
      viewOrganizations: 'Voir les Organisations',
      createNewOrg: 'Créer une Nouvelle Organisation',
      unassignedUsers: 'Utilisateurs Non Assignés ({{count}})',
      unassignedUsersWarning:
        'Ces utilisateurs se sont inscrits mais ne sont pas encore assignés à une organisation.',
      tableHeaders: {
        registered: 'Inscrit',
        assignToOrg: "Assigner à l'Organisation",
        assignRoles: 'Assigner des Rôles',
        action: 'Action',
        orgName: "Nom de l'Organisation",
      },
      selectOrganization: 'Sélectionner Organisation',
      noOrgsFound: 'Aucune organisation trouvée dans le système.',
      createOrgDialog: {
        title: 'Créer une Nouvelle Organisation',
        orgName: "Nom de l'Organisation *",
        orgNamePlaceholder: "Entrer le nom de l'organisation",
        slug: 'Slug : {{slug}}',
        creating: 'Création...',
        createOrg: 'Créer Organisation',
      },
    },

    // Drone Assignments Card
    droneAssignments: {
      title: 'Affectations de Drones',
      description:
        'Gérer les affectations de drones aux organisations. Réassigner les drones entre les organisations selon les besoins pour la flexibilité opérationnelle.',
      manageAssignments: 'Gérer les Affectations',
      dialogTitle: 'Affectations Organisation-Drone',
      tableHeaders: {
        serialNumber: 'Numéro de Série',
        currentOrg: 'Organisation Actuelle',
        status: 'Statut',
        ownershipType: 'Type de propriété',
        leaseEndDate: 'Fin de location',
        actions: 'Actions',
      },
      noOrgAssigned: 'Aucune organisation assignée',
      noDronesFound: 'Aucun drone trouvé dans le système.',
      noOwnership: 'Non défini',
    },

    // Maintenance Documents Card
    maintenanceDocs: {
      title: 'Documents de Maintenance',
      description:
        "Gérer la documentation de maintenance pour l'agent IA. Téléverser des manuels, procédures, spécifications d'outils et diagrammes pour un support de maintenance intelligent.",
      manageDocuments: 'Gérer les Documents',
      dialogTitle: 'Gestion des Documents de Maintenance',
      uploadSection: 'Téléverser un Nouveau Document',
      selectPdfFile: 'Sélectionner un Fichier PDF',
      selectedFile: 'Sélectionné : {{name}} ({{size}} Mo)',
      documentTitle: 'Titre du Document *',
      documentType: 'Type de Document *',
      docTypes: {
        manual: 'Manuel',
        procedure: 'Procédure',
        toolSpec: "Spécification d'Outil",
        diagram: 'Diagramme',
        safety: 'Document de Sécurité',
      },
      version: 'Version (Optionnel)',
      versionPlaceholder: 'v2.1, Rev 3, etc.',
      droneModel: 'Modèle de Drone (Optionnel)',
      droneModelPlaceholder: 'DJI Mavic 3, etc.',
      manufacturer: 'Fabricant (Optionnel)',
      manufacturerPlaceholder: 'DJI, Xer Technologies, etc.',
      uploading: 'Téléversement...',
      uploadDocument: 'Téléverser Document',
      uploadedDocuments: 'Documents Téléversés',
      noDocsYet: 'Aucun document téléversé. Téléversez votre premier document ci-dessus.',
      tableHeaders: {
        title: 'Titre',
        type: 'Type',
        size: 'Taille',
        status: 'Statut',
        uploaded: 'Téléversé',
        actions: 'Actions',
      },
      processed: 'Traité ({{chunks}} fragments)',
      notProcessed: 'Non Traité',
      reprocessDoc: 'Retraiter le document',
      processForAI: "Traiter le document pour l'agent IA",
      deleteDocument: 'Supprimer le document',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce document ?\n\nClé : {{key}}',
    },

    // Tender Emails Card
    tenderEmails: {
      title: "E-mails d'appels d'offres",
      description:
        "Voir les e-mails transférés à Trent (l'agent d'appels d'offres) et leurs évaluations IA. Surveiller l'activité du pipeline et retraiter les e-mails échoués.",
      viewEmails: 'Voir les e-mails',
      dialogTitle: "Évaluations des e-mails d'appels d'offres",
      filterStatus: 'Statut',
      allStatuses: 'Tous',
      refresh: 'Actualiser',
      noEmails: "Aucun e-mail d'appel d'offres trouvé.",
      tableHeaders: {
        subject: 'Objet',
        from: 'De',
        status: 'Statut',
        evaluation: 'Évaluation',
        confidence: 'Confiance',
        date: 'Reçu',
        actions: 'Actions',
      },
      reprocess: 'Retraiter cet e-mail',
      summary: 'Résumé',
      client: 'Client',
      deadline: 'Date limite',
      budget: 'Budget',
      keyFactors: 'Facteurs clés',
      reasoning: 'Analyse',
      replySent: 'Réponse envoyée',
      processedAt: 'Traité',
      scrapedLinks: 'Liens Extraits',
      attachments: 'Pièces Jointes',
      individualTenders: "Appels d'Offres Individuels",
      tenderTitle: "Appel d'Offres",
      pages: 'pages',
    },

    // Announcements Card
    announcements: {
      title: 'Annonces',
      description:
        'Envoyer des annonces à toute la plateforme aux utilisateurs et organisations. Suivre la livraison et le statut de lecture pour tous les messages envoyés.',
      manageAnnouncements: 'Gérer les Annonces',
      dialogTitle: 'Gestion des Annonces',
      sendNew: 'Envoyer une Nouvelle Annonce',
      announcementTitle: 'Titre *',
      messageBody: 'Corps du Message *',
      sendTo: 'Envoyer À *',
      targetTypes: {
        allUsers: 'Tous les Utilisateurs de la Plateforme',
        specificOrgs: 'Organisations Spécifiques',
        specificUsers: 'Utilisateurs Spécifiques',
      },
      selectOrganizations: 'Sélectionner les Organisations *',
      selectUsers: 'Sélectionner les Utilisateurs *',
      attachFiles: 'Joindre des Fichiers (Optionnel)',
      sendEmailNotification: 'Envoyer également une notification par e-mail',
      sending: 'Envoi...',
      sendAnnouncement: "Envoyer l'Annonce",
      sentSuccess: 'Annonce envoyée à {{count}} utilisateurs !',
      sentAnnouncements: 'Annonces Envoyées ({{count}})',
      tableHeaders: {
        title: 'Titre',
        created: 'Créé',
        recipients: 'Destinataires',
        readUnread: 'Lu / Non Lu',
      },
      by: 'par {{name}}',
      read: '{{count}} lus',
      unread: '{{count}} non lus',
      noAnnouncementsYet: "Aucune annonce envoyée pour l'instant.",
    },

    // Maintenance Recalculate Card
    maintenanceRecalculate: {
      title: 'Recalculer les Compteurs de Maintenance',
      description:
        "Recalculer tous les compteurs de maintenance d'un drone à partir de zéro. Reconstruit l'historique de maintenance et corrige les incohérences de données.",
      buttonLabel: 'Recalculer les Compteurs',
      selectDrone: 'Sélectionner le Drone',
      recalculate: 'Recalculer',
      recalculating: 'Recalcul en cours...',
      infoText:
        'Ceci recalculera tous les compteurs de maintenance à partir de zéro. Le système va :',
      infoBullet1:
        "Reconstruire l'historique de maintenance à partir de tous les enregistrements terminés et vérifiés",
      infoBullet2:
        "Réinitialiser tous les compteurs d'heures de vol et de moteur selon la maintenance effectuée",
      infoBullet3: 'Corriger les incohérences de données',
      resultComplete: 'Recalcul Terminé',
      resultSummary:
        '{{processed}} enregistrements de maintenance traités \u2022 {{reset}} compteurs mis à jour \u2022 {{unchanged}} inchangés',
      viewDetails: 'Voir les Détails',
      hideDetails: 'Masquer les Détails',
      totalFlightHours: 'Heures de Vol Totales',
      totalEngineHours: 'Heures de Moteur Totales',
      countersBreakdown: 'Détail des Compteurs de Maintenance',
      tableCounter: 'Compteur',
      tableLastMaintenance: 'Dernière Maintenance',
      tableFlightsSince: 'Vols Depuis',
      tableTotalHours: 'Heures Totales',
      tableRemaining: 'Restant',
      flightHoursLabel: 'Heures de Vol',
      engineHoursLabel: 'Heures de Moteur',
      byPerformer: 'par {{name}}',
      neverMaintained: 'Jamais maintenu',
      noFlights: 'Aucun vol',
    },

    // Invite User Dialog
    inviteUser: {
      dialogTitle: "Inviter un Utilisateur à l'Organisation",
      emailAddress: 'Adresse Email *',
      emailPlaceholder: 'utilisateur@exemple.com',
      emailHelperText: "L'utilisateur recevra un lien d'invitation par email",
      selectRoles: 'Sélectionner les Rôles *',
      selectRolesHelper: 'Choisissez un ou plusieurs rôles à attribuer à cet utilisateur',
      validation: {
        emailRequired: "L'email est requis",
        invalidEmail: 'Veuillez entrer une adresse email valide',
        selectRole: 'Veuillez sélectionner au moins un rôle',
      },
      invitationNote:
        "Le lien d'invitation expirera dans 24 heures. L'utilisateur sera automatiquement assigné à votre organisation lorsqu'il acceptera l'invitation.",
      cancel: 'Annuler',
      sending: 'Envoi...',
      sendInvitation: "Envoyer l'Invitation",
      failedToSend: "Impossible d'envoyer l'invitation",
    },
  },

  // User Guide (EN placeholder — pending translation)
  guide: {
    title: 'User Guide',
    subtitle: 'Workflow guides for common tasks',
    backToDashboard: 'Back to Dashboard',
    headerTooltip: 'User Guide',
    common: {
      tip: 'Tip',
      important: 'Important',
    },
    sections: {
      uploadFlightData: 'Uploading & Analyzing Flight Data',
      shareFlights: "Sharing a Drone's Flights",
      maintenanceRecords: 'Maintenance Records',
      maintenanceRecordsCreating: 'Creating a Record',
      maintenanceRecordsQuality: 'Quality Checks',
      maintenanceRecordsSchedules: 'Reading Schedules',
      healthPanel: 'Reading the Health Panel',
      healthPanelAvgr: 'Understanding AVGR',
      healthPanelAvgt: 'Understanding AVGT',
      healthPanelTuwt: 'Understanding TUWT',
      healthPanelAction: 'When to Take Action',
      droneNotes: 'Drone Notes & Timeline',
      droneNotesCreating: 'Creating Notes',
      droneNotesFilters: 'Using Filters',
      droneNotesTimeline: 'Timeline Interaction',
      llmChat: 'AI Chat Assistant',
      llmChatSql: 'SQL Query Agent',
      llmChatMaintenance: 'Maintenance Agent',
      llmChatTips: 'Tips & Limits',
      inviteUsers: 'Inviting Users & Assigning Roles',
    },
    uploadFlightData: {
      intro:
        'Flight data files (CSV) require metadata before upload. This workflow walks you through uploading files and optionally analyzing them first.',
      steps: {
        s1: "Accédez à l'onglet Fichiers.",
        s2: 'Open the folder where you want to upload files.',
        s3: 'Click "Upload Files" to expand the upload zone.',
        s4: 'Drag and drop files into the upload zone, or click to browse your computer.',
        s5: 'For CSV flight data files, fill in the required metadata: flight type, payload, and pilot. These fields are mandatory for flight data.',
        s6: 'Optionally, click "Analyze" on a file to preview extracted metadata (rows, columns, detected values) before uploading.',
        s7: 'Click the upload button to upload all selected files.',
      },
      tipDocuments:
        'Document files (PDF, images) do not require flight metadata — they are uploaded directly.',
      tipAnalyze:
        'Use the "Analyze" button to validate a file before uploading. This lets you confirm the file has the expected data without committing to an upload.',
      tipPlotting:
        'To visualize and explore uploaded flight data in detail, use the "Plot Flight Data" button in the dashboard header. It opens the plotting tool where you can browse your folder structure, select a CSV file, and chart individual parameters from the flight.',
    },
    shareFlights: {
      intro:
        'Your organization can share every flight of one drone with XER Technologies in one action, for example so XER can support the aircraft. Each shared flight comes with its CSV log file and the .bin logs linked to it.',
      steps: {
        s1: 'Go to the "{{files}}" tab, open "{{sharedWithMe}}" and pick the "{{flights}}" tab.',
        s2: 'Click "{{openBulk}}".',
        s3: '{{drone}}: pick the drone\'s serial number (for example 105). {{organization}}: XER Technologies. Leave "{{fromDate}}" empty: it uses the drone\'s recorded handover date. {{access}}: "{{read}}".',
        s4: 'Click "{{share}}". A message confirms how many flights were shared.',
      },
      whatTheySee:
        'The other organization then finds these flights under "{{sharedWithMe}}", "{{flights}}", "{{inbound}}", and can open and download each flight\'s CSV log file. "{{read}}" lets them see and download the flights and nothing more: they cannot change or delete them. Shared flights do not count toward the other organization\'s own fleet totals. To stop sharing a flight, use "{{unshare}}" on it under "{{outbound}}".',
      whereTheyAppear:
        'Besides "{{sharedWithMe}}", shared flights appear on the drone\'s own pages (its profile timeline, flight list and Health panel), each marked as shared by your organization, and the drone\'s counters there say how many shared flights they include.',
      warningAdmins: 'Only organization admins see the "{{openBulk}}" button.',
      tipReshare:
        'Sharing covers the flights uploaded so far, not later ones. After you upload new flights for the drone, repeat these steps and click "{{share}}" again: only the new flights are added, and flights that are already shared are skipped.',
      tipBinLogs:
        '"{{openBulk}}" shares the drone\'s CSV flight logs, and every .bin log linked to one of those flights. When you upload a .bin log, the Dashboard looks for a flight of the same day with a matching start time and asks whether they are the same flight: answer "{{sameFlight}}" to link them. For a .bin log uploaded earlier, right-click it in the "{{files}}" tab and choose "{{linkFlight}}". A linked log follows the flight: whoever the flight is shared with can open it, and revoking the flight share withdraws it. Sharing the folder that holds the .bin logs ("{{shareFolder}}", XER Technologies under "{{folderOrganization}}", "{{folderShare}}") still works as well.',
      tipHandoverDate:
        'If the dialog says no handover date is recorded for the drone, enter the date your organization took the drone over in "{{fromDate}}" and click "{{share}}" again. Flights before that date are XER\'s own acceptance flights and are not shared.',
    },
    maintenanceRecords: {
      intro:
        'Maintenance records track work performed on a drone. Creating a record and having it quality-checked are separate steps done by different users.',
      layoutDescription:
        'The Maintenance tab has two panels: Upcoming Maintenance shows what is due or overdue based on hour intervals, and Maintenance History shows completed records.',
      creating: {
        steps: {
          s1: 'Select a drone, then navigate to the Maintenance tab.',
          s2: 'Click "Add Maintenance" to open the maintenance record form.',
          s3: 'Select one or more maintenance types. You can also create a new type on-the-fly if the one you need does not exist.',
          s4: 'Fill in the work description explaining what was done.',
          s5: 'Select who performed the maintenance.',
          s6: 'Set the start and end dates for when the work was carried out.',
          s7: 'Attach any evidence files (photos, reports) during creation.',
          s8: 'Save the record.',
        },
      },
      warningAttachments:
        'File attachments can only be added when creating the record. You cannot attach files after the record has been saved.',
      quality: {
        description:
          'After a maintenance record is created, a different user must quality-check it. The person who created the record cannot approve their own work.',
        warningDifferentUser:
          'Quality checks require a different user than the one who created the record. This is enforced by the system.',
      },
      schedules: {
        description:
          'Upcoming maintenance is based on hours-based intervals configured for each maintenance type. The panel shows how many hours remain until maintenance is due, or how many hours overdue it is. Red indicators mean the maintenance is overdue and should be performed as soon as possible.',
      },
      tipNewTypes:
        'You can create new maintenance types on-the-fly from the maintenance record form. This is useful when a new type of work is performed for the first time.',
    },
    healthPanel: {
      intro:
        'The Health Panel provides automated analysis of drone sensor data. It uses three different metric types to give you a complete picture of system health.',
      openingSteps: {
        s1: 'Select a drone from the fleet overview.',
        s2: 'Navigate to the Health Panel tab.',
        s3: 'Review the metric cards organized by system (Performance, Cooling, Batteries, etc.).',
      },
      avgr: {
        title: 'AVGR (Average Reading)',
        description:
          'AVGR shows a single value: the latest average reading for a sensor. It includes a status indicator — NORMAL (within expected range) or WARNING (outside expected range). Use this to quickly check if a sensor is currently within acceptable limits.',
      },
      avgt: {
        title: 'AVGT (Average Trend)',
        description:
          'AVGT shows a historical trend line calculated using linear regression. It includes a trend direction (IMPROVING, STABLE, or WORSENING), a forecast value for a future date, and an R² confidence score. Higher R² means the forecast is more reliable.',
        warningRSquared:
          'A low R² value (below 0.5) means the data has high variability and the forecast may not be reliable. Do not make critical decisions based on low-confidence forecasts alone.',
      },
      tuwt: {
        title: 'TUWT (Time Under Warning Threshold)',
        description:
          'TUWT shows how much time a sensor spent in warning or error state, expressed as a percentage of total monitoring time. Warning time means the sensor was outside normal range. Error time means the sensor was in a critical state.',
      },
      action: {
        description:
          'Consider taking action when: TUWT error percentage is high, AVGT shows a worsening trend with high R², or AVGR shows WARNING status consistently. Combine multiple indicators rather than relying on any single metric.',
      },
      tipDataPoints:
        'Trend analysis requires at least 3 data points. With fewer data points, the Health Panel will show the message "Insufficient data for trend analysis" instead of a forecast.',
    },
    droneNotes: {
      intro:
        'Notes let you document observations, customer feedback, and alerts for a drone. The timeline view connects notes to flight data visually.',
      creating: {
        steps: {
          s1: 'Select a drone, then navigate to the Profile tab.',
          s2: 'Click "Create Note" (or the + button) in the Notes section.',
          s3: 'Enter a subject line for the note.',
          s4: 'Select the note type: General, Customer Feedback, or Alert.',
          s5: 'Set the priority: Information or Critical.',
          s6: 'Write the note content.',
          s7: 'Save the note.',
        },
      },
      filters: {
        description:
          'Use the filter controls to narrow down the notes list. You can filter by type (General, Customer Feedback, Alert), priority (Information, Critical), and whether resolved notes are included.',
      },
      timeline: {
        description:
          'The timeline at the top of the Profile tab shows a Gantt chart of flight data. Clicking a flight bar in the timeline scrolls down to and highlights the corresponding note below. This helps you connect specific flights to related observations.',
        tipDateRange:
          'The date range slider filters the notes list but does not affect the timeline view. The timeline always shows all available data.',
      },
    },
    llmChat: {
      intro:
        'The platform includes an AI chat assistant accessible via the floating button in the bottom-right corner of the dashboard. You choose an agent, then ask questions in natural language.',
      steps: {
        s1: 'Click the chat bubble in the bottom-right corner of the screen.',
        s2: 'Select an agent: SQL Query Agent for data questions, or Maintenance Agent for technical documentation.',
        s3: 'Type your question or click one of the example queries shown.',
        s4: 'Review the response. For SQL queries, you can expand "View SQL" to see the exact query that was executed.',
      },
      sql: {
        title: 'SQL Query Agent',
        description:
          'Ask questions about your fleet data in plain language. The agent converts your question into a SQL query, runs it against the database, and returns the results in readable form. You only see data from your own organization — this is enforced automatically.',
        examples:
          'Example questions: "How many flights under 10 minutes for drone 102?", "What is the total flight time this month?", "Show me drones that need maintenance", "How many unresolved notes are there?"',
      },
      maintenance: {
        title: 'Maintenance Agent',
        description:
          'Ask questions about maintenance procedures, safety protocols, and technical specifications. The agent searches uploaded maintenance documentation (manuals, procedures, tool specs) and synthesizes an answer with source citations. Answers reference specific document sections and page numbers.',
        examples:
          'Example questions: "How do I replace the propellers?", "What are the safety protocols for battery maintenance?", "Troubleshooting steps for motor failure", "What tools do I need for routine inspection?"',
      },
      tips: {
        rateLimit:
          'You are limited to 20 queries per hour. The limit resets automatically. If you reach it, wait and try again later.',
        feedback:
          'Use the thumbs up/down buttons on responses to provide feedback. This helps improve the quality of answers over time. Thumbs down lets you add an optional comment explaining what was wrong.',
        privacy:
          'All queries are scoped to your organization. The SQL agent can only read data — it cannot modify, delete, or create anything in the database.',
        session:
          'The chat remembers your conversation within a session. Click the refresh icon in the chat header to start a new session and switch agents.',
      },
    },
    inviteUsers: {
      intro:
        'When you invite a user, they receive an email link. Once they accept and create their account, they are automatically assigned to your organization with the roles you selected.',
      steps: {
        s1: 'Navigate to Admin Tools.',
        s2: 'In the User Management section, click "Invite User".',
        s3: "Enter the user's email address and select one or more roles.",
        s4: 'Click "Send Invitation". The user receives an email with a link to create their account.',
        s5: 'When the user clicks the link and creates their password, they are automatically assigned to your organization with the selected roles.',
        s6: 'The user can now sign in and access the system immediately.',
      },
      warningExpiry:
        'Invitation links expire in 24 hours. If the link expires, you need to send a new invitation.',
      warningUnassigned:
        'The "Unassigned Users" list in Organization Management shows users who registered on their own (without an invitation). These users must be manually assigned to an organization by an admin before they can access the system.',
    },
  },

  inventory: {
    title: 'Inventaire',
    locations: 'Emplacements',
    items: 'Articles',
    allItems: 'Tous les articles',
    addLocation: 'Ajouter un emplacement',
    addItem: 'Ajouter un article',
    editLocation: "Modifier l'emplacement",
    editItem: "Modifier l'article",
    deleteLocation: "Supprimer l'emplacement",
    deleteItem: "Supprimer l'article",
    confirmDeleteLocation:
      'Voulez-vous vraiment supprimer cet emplacement ? Tous les emplacements enfants seront également supprimés. Les articles dans les emplacements supprimés ne seront plus assignés.',
    confirmDeleteItem: 'Voulez-vous vraiment supprimer cet article ?',
    name: 'Nom',
    locationType: 'Type',
    parentLocation: 'Emplacement parent',
    notes: 'Notes',
    quantity: 'Quantité',
    category: 'Catégorie',
    location: 'Emplacement',
    search: 'Rechercher des articles...',
    noLocations: 'Aucun emplacement. Ajoutez votre premier emplacement pour commencer.',
    noItems: 'Aucun article trouvé.',
    noItemsInLocation: 'Aucun article dans cet emplacement.',
    sortOrder: 'Ordre de tri',
    locationTypes: {
      area: 'Zone',
      shelf: 'Étagère',
      level: 'Niveau',
      box: 'Boîte',
      pelicase: 'Pelicase',
      bag: 'Sac',
      section: 'Section',
      bucket: 'Seau',
      container: 'Conteneur',
    },
    actions: 'Actions',
    searchLocations: 'Rechercher des emplacements...',
    locationPath: "Voir le chemin de l'emplacement",
    backTo: 'Retour à {{name}}',
    rootLevel: 'Racine',
    noSelection: 'Aucune sélection',
  },

  operationsEquipment: {
    title: 'Équipement opérationnel',
    add: 'Ajouter un équipement',
    addTitle: 'Ajouter un équipement',
    edit: 'Modifier',
    editTitle: "Modifier l'équipement",
    delete: "Supprimer l'équipement",
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet équipement ?',
    name: 'Nom',
    location: 'Emplacement',
    quantity: 'Quantité',
    drone: 'Drone',
    photo: 'Photo',
    photoUrl: 'URL de la photo',
    notes: 'Notes',
    actions: 'Actions',
    noEquipment: 'Aucun équipement opérationnel. Ajoutez votre premier équipement pour commencer.',
  },

  // Manufacturing (STD-015 query/mutation error fallbacks)
  manufacturing: {
    failedToCheckAccess: "Échec de la vérification de l'accès à la fabrication",
    failedToLoad:
      "Échec du chargement des données de fabrication. Vérifiez que les scripts d'instantané ont été exécutés.",
    failedToLoadPartDetail: 'Échec du chargement du détail de la pièce',
    failedToSimulate:
      'La simulation a échoué. Confirmez que le produit possède une nomenclature et réessayez.',
  },

  // Partage de vols (#1182 Etape 3) — il ne reste que le dialogue en masse par
  // numero de serie ; les chaines du dialogue par fichier ont ete retirees avec
  // lui en B-6 (STD-029 R-12), voir en.ts.
  flightShares: {
    selectOrganization: 'Organisation',
    permission: 'Acces',
    permissionRead: 'Lecture',
    permissionWrite: 'Lecture + modification des details',
    permissionHelp:
      "Lecture permet a l'autre organisation de voir et telecharger les vols. Lecture + modification des details lui permet aussi de modifier les details de chaque vol (type, pilote, charge utile, client, projet). Seule votre organisation peut supprimer un vol.",
    nothingNewToShare: 'Tous les vols correspondants etaient deja partages - rien a faire.',
    sharedOne: '1 vol partage.',
    sharedOther: '{{count}} vols partages.',
    skippedOne: '1 etait deja partage.',
    skippedOther: '{{count}} etaient deja partages.',
    droneOwnedBy: 'Appartient a {{org}}.',
    droneFlightsOne: '1 vol enregistre par votre organisation avec lui.',
    droneFlightsOther: '{{count}} vols enregistres par votre organisation avec lui.',
    noShareableDrones: "Votre organisation n'a pas encore de vols enregistres a partager.",
    onlyAdmins: "Seuls les administrateurs de l'organisation peuvent modifier le partage.",
    bulkTitle: "Partager les vols d'un drone",
    bulkIntro:
      'Partage en une seule action tous les vols que votre organisation a enregistres pour ce drone, plutot que un par un. Reexecutable : les vols deja partages sont ignores.',
    drone: 'Drone',
    fromDate: 'A partir du',
    toDate: "Jusqu'au",
    fromDateHelp: 'Laisser vide pour utiliser la date de remise enregistree du drone.',
    bulkShare: 'Partager les vols',
    errors: {
      noSoldDate:
        "Aucune date de remise n'est enregistree pour le drone {{serial}} : il n'existe donc pas de coupure defendable entre les vols de XER anterieurs a la remise et ceux du client. Saisissez ci-dessous, dans \"A partir du\", la date a laquelle le client a pris l'aeronef.",
      noFlights: "Aucun vol de votre organisation ne correspond - rien n'a ete partage.",
      illegalPairing:
        "Les vols ne peuvent etre partages qu'entre XER Technologies et une organisation cliente, dans les deux sens, jamais entre deux clients.",
    },
  },

  objectShares: {
    menuItemFile: 'Partager le fichier...',
    menuItemFolder: 'Partager le dossier...',
    menuItemMany: 'Partager {{count}} elements...',

    dialogTitle: 'Partage - {{name}}',
    dialogTitleMany: 'Partage de {{count}} elements',
    multiSelection:
      "Les {{count}} elements selectionnes seront partages. Les partages existants sont conserves : ce qui est deja partage avec l'organisation choisie est ignore.",
    folderCoversFutureFiles:
      "Partager un dossier partage aussi tout son contenu, y compris les fichiers ajoutes ensuite. Il n'est pas necessaire de partager chaque nouveau fichier.",
    currentShares: 'Acces actuel',
    noShares: "Ceci n'est partage avec personne.",
    sharedWithOrg: 'Partage avec {{org}}',
    sharedByOrg: 'Partage avec nous par {{org}}',
    sharedDirectionUnknown: 'Partage (destinataire indisponible)',
    unknownOrg: 'Une autre organisation',
    grantedOn: 'Accorde le {{date}}',

    revoke: 'Ne plus partager',
    revokeConfirm: "Cesser de partager ce fichier avec {{org}} ? L'acces prend fin immediatement.",
    revokeConfirmFolder:
      "Cesser de partager ce dossier avec {{org}} ? Ils perdent l'acces a tout son contenu, y compris aux fichiers ajoutes depuis le partage.",
    revokeSuccess: 'Partage arrete.',

    shareWith: 'Partager avec',
    selectOrganization: 'Organisation',
    permission: 'Acces',
    permissionRead: 'Lecture',
    permissionWrite: 'Lecture + ecriture',
    permissionHelp:
      "Lecture permet a l'autre organisation de voir et de telecharger ce fichier. Lecture + ecriture lui permet en plus de le renommer. Seule votre organisation peut le supprimer.",
    permissionHelpFolder:
      "Lecture permet a l'autre organisation de voir et de telecharger tout le contenu de ce dossier, y compris les fichiers ajoutes ensuite. Lecture + ecriture lui permet en plus d'y creer des dossiers et de renommer ou deplacer les elements qu'il contient. Elle ne peut pas encore y deposer de fichiers depuis l'onglet Fichiers, car ces envois ne seraient pas traites comme des vols. Seule votre organisation peut supprimer son contenu.",
    share: 'Partager',
    noCounterparties: 'Aucune organisation avec laquelle vous pouvez partager ceci.',
    sharedOne: '1 element partage.',
    sharedOther: '{{count}} elements partages.',
    skippedOne: '1 etait deja partage.',
    skippedOther: '{{count}} etaient deja partages.',
    onlyAdmins: "Seuls les administrateurs de l'organisation peuvent modifier le partage.",

    errors: {
      noObjects:
        "Aucun des elements selectionnes n'appartient a votre organisation : il n'y avait rien a partager.",
      illegalPairing:
        "Les fichiers ne peuvent etre partages qu'entre XER Technologies et une organisation cliente, dans les deux sens, jamais entre deux clients.",
    },
  },

  flightLinks: {
    menuItem: 'Lier a un vol...',
    dialogTitle: 'Lier a un vol - {{name}}',
    intro:
      'Un journal .bin lie a un vol le suit : chaque organisation avec laquelle le vol est partage peut ouvrir et tracer le journal. Le delier, ou revoquer le partage du vol, le retire de nouveau.',
    current: 'Lie a',
    noLinks: "Ce journal n'est lie a aucun vol.",
    candidates: 'Vols auxquels ce journal peut appartenir',
    day: 'Jour',
    logStart: "Journal demarre {{time}} (d'apres le nom du fichier).",
    noLogStart:
      "Le nom du fichier ne contient pas d'heure de debut, aucun vol n'est donc marque. Choisissez le jour de l'enregistrement.",
    noCandidates:
      "Aucun vol visible de l'organisation de ce journal ce jour-la. Choisissez un autre jour.",
    proposed: 'Correspondance probable',
    deltaLogName: '{{minutes}} min du nom du CSV',
    deltaFirstSample: '{{minutes}} min du premier echantillon (UTC)',
    flightOn: 'Drone {{serial}}, {{date}}',
    sharedWith: 'Partage avec {{orgs}} : le lier leur donne ce journal',
    sharedWithLinked: 'Partage avec {{orgs}}, qui peuvent ouvrir ce journal',
    notShared: 'Vol non partage',
    unknownOrg: 'Autre organisation',
    link: 'Lier',
    unlink: 'Delier',
    unlinkConfirm:
      "Delier ce journal du vol ? Les organisations avec lesquelles le vol est partage perdent immediatement l'acces au journal.",
    linked: 'Lie.',
    alreadyLinked: 'Deja lie.',
    unlinked: 'Delie.',
    promptTitle: 'Est-ce le meme vol ?',
    promptQuestion: '{{bin}} et {{flight}} ont commence presque au meme moment.',
    promptNo: 'Non',
    promptYes: "Oui, c'est le meme vol",
  },

  sharedView: {
    navLabel: 'Partage avec moi',
    title: 'Partage avec moi',
    backToFiles: 'Retour aux fichiers',
    kindFlights: 'Vols',
    kindFiles: 'Fichiers',
    flightsIntro: "Vols partages entre votre organisation et d'autres.",
    flightsIntroDetail:
      'Un vol partage comporte son fichier journal et les journaux .bin qui lui sont lies, qui s\'ouvrent donc comme n\'importe quel autre fichier. Ce que votre organisation partage figure sous "Partage par nous" ; ce que d\'autres partagent avec vous, sous "Partage avec nous".',
    filesIntro: "Fichiers et dossiers partages entre votre organisation et d'autres.",
    filesIntroDetail:
      "Partager un dossier partage tout ce qu'il contient, y compris les fichiers ajoutes ensuite - des elements peuvent donc apparaitre ici sans avoir ete partages individuellement.",
    aboutThisPage: 'A propos de cette page',

    outbound: 'Partage par nous',
    inbound: 'Partage avec nous',
    allShares: 'Tous les partages',
    filterCounterparty: 'Organisation',
    allCounterparties: 'Toutes les organisations',
    unknownOrg: 'Une autre organisation',
    includeRevoked: 'Inclure les partages revoques',
    openBulk: "Partager les vols d'un drone",
    onlyAdmins: "Seuls les administrateurs de l'organisation peuvent modifier le partage.",

    permissionRead: 'Lecture',
    permissionWrite: 'Lecture + ecriture',
    droneChip: 'Drone {{serial}}',
    flightOn: 'Vol {{date}}',
    trackLabel: 'Trace DroneLogbook · {{date}}',
    trackLabelUndated: 'Trace DroneLogbook',
    trackTooltip: 'Un enregistrement de vol DroneLogbook, sans fichier journal.',
    grantedOn: 'Accorde le {{date}}',
    revokedOn: 'Revoque {{date}}',
    unnamedEntry: 'Fichier indisponible',

    openFolder: 'Ouvrir le dossier',
    download: 'Telecharger',
    downloadStarted: 'Telechargement demarre.',
    plot: 'Ouvrir dans Analytics',
    revoke: 'Ne plus partager',
    revokeConfirm:
      "Cesser de partager ceci avec {{org}} ? L'acces prend fin immediatement ; ce qui en a deja ete tire reste valide.",
    revokeSuccess: 'Partage arrete.',

    rowsPerPage: 'Elements par page',
    paginationRange: '{{from}}-{{to}} sur {{count}}',
    noneShared: "Il n'y a encore rien ici.",
    noneForOrg: 'Aucun partage avec cette organisation.',
    emptyOutboundFlights:
      "Aucun vol n'est actuellement partage par votre organisation. Un administrateur de l'organisation peut partager les vols d'un drone depuis cette page.",
    emptyOutboundFiles:
      "Aucun fichier ni dossier n'est actuellement partage par votre organisation. Partagez-en un depuis son menu dans Fichiers.",
    emptyInboundFlights:
      'Aucune organisation ne partage actuellement de vols avec la votre. Les vols partages avec vous apparaissent ici, avec leurs fichiers journaux.',
    emptyInboundFiles:
      'Aucune organisation ne partage actuellement de fichiers ni de dossiers avec la votre.',
  },
} as const;
